// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-button {
  display: block;
  padding: 5px;
  margin: 8px;
  border-radius: 20px;
  font-family: "Phenoma Light", "Segoe UI", Arial, sans-serif;
  font-size: calc(20px + 2pt);
  border: 1px solid #1a6a7c;
  cursor: pointer;
  box-shadow: 2px 2px 4px 0 rgba(0, 0, 0, 0.4);
}

.default-button {
  background-color: #ffffff;
  color: #1a6a7c;
}

.menu-item {
  font-family: "Phenoma Light", "Segoe UI", Arial, sans-serif;
  font-size: calc(20px + 2pt);
  text-align: left;
}

.menu-item:hover {
  transform: none;
  background-color: rgba(238, 250, 247, 1);
}

.primary-button {
  background-color: #1a6a7c;
  color: white;
}

button:hover {
  transform: scale(1.05);
  transition-duration: 200ms;
}

.custom-button:disabled {
  background-color: lightgray;
  transform: none;
}
`, "",{"version":3,"sources":["webpack://./src/Components/StyledComponents/Buttons.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,2DAA2D;EAC3D,2BAA2B;EAC3B,yBAAyB;EACzB,eAAe;EACf,4CAA4C;AAC9C;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,2DAA2D;EAC3D,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,eAAe;AACjB","sourcesContent":[".custom-button {\n  display: block;\n  padding: 5px;\n  margin: 8px;\n  border-radius: 20px;\n  font-family: \"Phenoma Light\", \"Segoe UI\", Arial, sans-serif;\n  font-size: calc(20px + 2pt);\n  border: 1px solid #1a6a7c;\n  cursor: pointer;\n  box-shadow: 2px 2px 4px 0 rgba(0, 0, 0, 0.4);\n}\n\n.default-button {\n  background-color: #ffffff;\n  color: #1a6a7c;\n}\n\n.menu-item {\n  font-family: \"Phenoma Light\", \"Segoe UI\", Arial, sans-serif;\n  font-size: calc(20px + 2pt);\n  text-align: left;\n}\n\n.menu-item:hover {\n  transform: none;\n  background-color: rgba(238, 250, 247, 1);\n}\n\n.primary-button {\n  background-color: #1a6a7c;\n  color: white;\n}\n\nbutton:hover {\n  transform: scale(1.05);\n  transition-duration: 200ms;\n}\n\n.custom-button:disabled {\n  background-color: lightgray;\n  transform: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
